/**
 * SPRINT V3 — Quiniela Social.
 * Local group prediction pool — user creates a quiniela, shares the
 * join link, and tracks how many friends joined. Pure client state;
 * actual scoring lives in the existing Quinielas module. This file
 * only powers the viral invite loop.
 */
const KEY = "ss2026_v3_quinielas";

export interface SocialQuiniela {
  id: string;
  name: string;
  matchId: string | null;
  createdAt: number;
  joinedCount: number; // self-reported (incremented locally on share+accept)
}

interface State { items: SocialQuiniela[] }

function read(): State {
  if (typeof window === "undefined") return { items: [] };
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return { items: [] };
    return JSON.parse(raw) as State;
  } catch { return { items: [] }; }
}
function write(s: State) {
  if (typeof window === "undefined") return;
  try { window.localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* noop */ }
}

function genId(): string { return "Q" + Math.random().toString(36).slice(2, 8).toUpperCase(); }

export function listQuinielas(): SocialQuiniela[] {
  return read().items.slice(-5).reverse();
}

export function createSocialQuiniela(opts: { name: string; matchId: string | null }): SocialQuiniela {
  const s = read();
  const q: SocialQuiniela = {
    id: genId(),
    name: opts.name.slice(0, 32) || "Quiniela",
    matchId: opts.matchId,
    createdAt: Date.now(),
    joinedCount: 0,
  };
  s.items.push(q);
  write(s);
  return q;
}

export function bumpQuinielaJoin(id: string) {
  const s = read();
  const q = s.items.find((x) => x.id === id);
  if (!q) return;
  q.joinedCount += 1;
  write(s);
}
